// extracted by mini-css-extract-plugin
module.exports = {"formFieldPairComment":"CommentPlexTranslationDialog_form-field-pair-comment__1pXak"};